import { RELATIONSHIP_TYPE_CHILD, RELATIONSHIP_TYPE_SELF } from '~/constants';

export const TELEMED_VISIT_COST_CENTS = 4900;
export const TELEMED_VISIT_COST_STRING = '$49';

export const TELEMED_SLA_MINUTES = 15;

export const MEMBERSHIP_COST_CENTS = 1499;
export const MEMBERSHIP_COST_STRING = '$14.99';

export const MEMBERSHIP_CARD_FEE = '$3';
export const STEADYMD_FEE = '$38';

export const MEMBERSHIP_SUPPORT_EMAIL = 'plussupport@solvhealth.com';

export const MEMBERSHIP_NAME = 'Solv Plus';

export const MEMBERSHIP_SUPPORTED_STATES = ['CA', 'TX', 'NY', 'NJ', 'CT', 'MA', 'WA', 'GA', 'PA'];
export const MEMBERSHIP_SUPPORTED_RELATIONSHIPS = [RELATIONSHIP_TYPE_SELF, RELATIONSHIP_TYPE_CHILD];
